<div class="flex flex-row items-center justify-center p-2 gap-2 text-sm text-slate-400">
    <div>An error was encountered</div>
    <div>🐛</div>
</div>